

import { Edit } from "@mui/icons-material"; // Import the MUI Edit icon
import React, { useEffect, useState } from "react";
import { BsFacebook, BsInstagram, BsYoutube } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import ManagerHeader from "./ManagerHeader"; // Import the ManagerHeader component
import Navbar from "./Navbar"; // Import the Navbar component

const ManagerProfile = () => {
  const [manager, setManager] = useState(null);
  const [error, setError] = useState(null);
    const [isSmallScreen, setIsSmallScreen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("mangertoken");
    const managerId = localStorage.getItem("managerID");
    if (!token || !managerId) {
      navigate("/ManagerLogin");
      return;
    }
  }, [navigate]);

  useEffect(() => {
    fetch(`https://server-side-influencer.onrender.com/manager/managers/${localStorage.getItem('managerID')}`)
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          setManager(data.data);
        } else {
          setError(data.error || "Manager not found");
        }
      })
      .catch(() => {
        setError("Server error. Please try again later.");
      });
  }, []);

    useEffect(() => {
      const handleResize = () => {
        setIsSmallScreen(window.innerWidth <= 800);
      };
  
      handleResize(); // Check initial size
      window.addEventListener('resize', handleResize);
  
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }, []);
  const handleEditClick = () => {
    navigate("/updateagency"); // Navigate to the update agency page
  };

  if (error) {
    return <div className="text-red-500 text-center">Error: {error}</div>;
  }

  return (
    <div className="flex h-screen mb-0">
    <div className="text-white fixed top-0 left-0 bottom-0 z-10">
      <Navbar />
    </div>

      <div className="w-full">
        <ManagerHeader page="Manager Profile" />

        {/* Profile Background and Picture */}
        <div className="relative h-96 w-full bg-gray-200 flex justify-center items-center mb-6" style={{ marginBottom: '100px' }}>
          <div className="absolute inset-0 bg-cover bg-center" style={{ backgroundImage: `url(${manager?.backgroundImage || "https://i.postimg.cc/QM0NNSx2/dummyd.png"})` }}></div>
          <div className="absolute inset-0 bg-black bg-opacity-30"></div>
          <div className="absolute bottom-[-50px] flex flex-col items-center">
            <img
              className="w-28 h-28 rounded-full border-4 border-white shadow-lg object-cover"
              src={manager?.profilePic || "https://i.postimg.cc/brqZVdrP/dummypic.jpg"}
              alt="Profile"
            />
            <a
              onClick={handleEditClick}
              className="absolute bottom-0 right-0 bg-white p-1 rounded-full shadow-md cursor-pointer"
            >
              <Edit className="text-gray-600" />
            </a>
          </div>
        </div>

        {/* Manager Info Box pushed towards the bottom */}
        <div
      className="px-8 py-12 bg-white rounded-t-2xl shadow-lg text-center w-3/4 mx-auto"
      style={{
        marginTop: '50px',
        marginBottom: '0px',
        marginLeft: isSmallScreen ? '59px' : '170px', // Conditional margin based on screen sizess
      }}
    >
          <div className="grid grid-cols-2 gap-4 text-left justify-center mx-auto w-full max-w-lg">
            <p className="text-xs sm:text-sm md:text-base"><strong>Full Name:</strong> {manager?.name || "John Doe"}</p>
            <p className="text-xs sm:text-sm md:text-base"><strong>Mobile:</strong> {manager?.phone || "N/A"}</p>
            <p className="text-xs sm:text-sm md:text-base"><strong>Email:</strong> {manager?.email || "N/A"}</p>
            {/* <p className="text-xs sm:text-sm md:text-base"><strong>Location:</strong> {manager?.city}, {manager?.state}, {manager?.country}</p> */}
            <p className="text-xs sm:text-sm md:text-base"><strong>Bio:</strong> {manager?.bio || "N/A"}</p>
            <p className="text-xs sm:text-sm md:text-base"><strong>About:</strong> {manager?.about || "N/A"}</p>
            <p className="text-xs sm:text-sm md:text-base flex items-center space-x-2">
              <strong>Socials:</strong>
              <a target="_blank" href={manager?.facebookURL} title="Facebook"><BsFacebook size={20} color="#3b5998" /></a>
              <a target="_blank" href={manager?.youtubeLink} title="YouTube"><BsYoutube size={20} color="#3b5998" /></a>
              <a target="_blank" href={manager?.instagramURL} title="Instagram"><BsInstagram size={20} color="#C13584" /></a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ManagerProfile;
